import { render, staticRenderFns } from "./HeaderMainMyAccount.vue?vue&type=template&id=60644017&scoped=true&"
import script from "./HeaderMainMyAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderMainMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainMyAccount.vue?vue&type=style&index=0&id=60644017&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60644017",
  null
  
)

export default component.exports